import dotenv from 'react-dotenv'

const exp = {
    env: dotenv.REACT_APP_ENV,
    backendBaseUrl: dotenv.REACT_APP_BACKEND_BASE_URL
}

export default exp